import React from "react";
import { HTML } from 'components/Elements';
import { BlockLayout } from '../BlockLayout';

export const TextBlock = ({ title, body }) => (
    <BlockLayout title={title}>
        <HTML>{body}</HTML>
    </BlockLayout>
)